import { Observable } from "rxjs";
import { CausalRechazoModel } from "../causal-rechazo.model";

export abstract class CausalRechazoGateway {
    abstract findAll(): Observable<CausalRechazoModel[]>;
}